import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './routes';
import theme from './theme';
import "./assets/styles/index.scss"
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify"

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
        <ToastContainer
          limit={3}
          newestOnTop={true}
          theme="dark"
          toastClassName="custom-toast"
          bodyClassName="custom-toast-body"
        />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);
